import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';


import Progress from '../partials/Progress';
import ContainerTranslation from "../partials/ContainerTranslation";
import { fetchRex,extractRex} from '../../actions/rex'

class RexView extends React.Component {

  fourth = React.createRef();

  constructor(props) {
    super(props);
    this.props.fetchRex(this.props.match.params.id);
  }



  componentDidUpdate(prevProps) {
    if(this.props.rexExtract && this.props.message === "Extract Rex" ){
      // const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      // const wordBlob = new Blob([this.props.rexExtract.data], { type: mimeType }, "word.docx");
    
      // saveAs(wordBlob, "Rex.docx")
    }

  }

  handleExtract(){

    this.props.extractRex(this.props.match.params.id);

  } 

  renderSubSection(field,path){
    return (
      <div key = {"subsection."+ path + '.' + field}>
        <p key = {"subsection-name"+ path + '.' + field} className="bloc-title" style={{ marginBottom: 0, color:'black' }}>
          {field}
        </p>
        <p key = {"subsection-value"+ path + '.' + field} className="bloc-content" style={{ color:'#989DA3' }}>
          {_.get(this.props.rex.content,path + '.' + field)}
          <br key = {"subbr"+ path + '.' + field}/>
        </p>
      </div>
    )
  }

  renderRecommandationSubSection(path){
    const field = 'recommandation';
    return (
      <div key = {"subsection."+ path + '.' + field}>
        <p key = {"subsection-name"+ path + '.' + field}  style={{ marginBottom: 0 , paddingBottom:"10px", color:'black'}}>
          Recommandations
        </p>
        <p key = {"subsection-value"+ path + '.' + field} className="bloc-content" style={{ color: '#181E23' }}>
          {_.get(this.props.rex.content,path + '.' + field).map((recommandation, i) => <div key={'conclusion-recommandations' + i} style={{ display: 'block' }}>
                      <div className="bloc-content" style={{ paddingLeft:"10px"}}>
                        <div className="bloc-content">
                          <div style={{display:'inline-block', width:'50%'}}>
                            <p style={{fontSize:"14px"}}>Date de cloture attendue : {recommandation['closure-date']}</p>
                          </div>
                          <div style={{display:'inline-block', width:'50%'}}>
                            <p style={{fontSize:"14px"}}>DDC : {recommandation['DDC']}</p>
                          </div>
                        </div>
                        <div className="bloc-content">
                          <p style={{fontSize:"14px"}}>Personne en charge : {recommandation.author}</p>
                        </div>
                        <div className="bloc-content">
                          <p style={{fontSize:"14px"}}>Recommandation :</p>
                        </div>
                        <div className="bloc-content">
                        <p style={{fontSize:"14px"}}>{recommandation.recommandation}</p>  
                        </div>
                        <div key={'separator-' + path + '.' + i} className="separator"></div>               
                      </div>
                    </div>)
          }
          <br key = {"subbr"+ path + '.' + field}/>
        </p>
      </div>
    )
  }



  renderSection_V2(fields,paths){
    const mainKey = paths.join()
    return (       
    <div  key = {"section1"+ mainKey} className={"formulaire wide"}>   
      <div key = {"section2"+ mainKey} className="bloc">
        {_.map(paths, (path)=>{
          return (<div key = {"section3"+ mainKey + path}> <span key = {"section-name"+ mainKey + path}>{path}</span>
                {_.map(fields,(field) => {
                    return field === "recommandation" ?  this.renderRecommandationSubSection(path) : this.renderSubSection(field,path)
                  })
                }
                <br key = {"br"+ mainKey + path}></br>
                </div>
              )
            } 
          )
        }
      </div>
    </div>
    )
  }


  render() {
    

    const sectionStructure = ['overview','observation','recommandation'];


    let route = null;

    if (Object.keys(this.props.rex).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    }

    if (this.props.rex.authorization.write) {
      route = "/rex/edit/" + this.props.rex._id
    };



    // {/* <button className="primary-btn filling" style={{float:"right",width:"156px",height:"48px"}} onClick={this.togglePopup.bind(this)} >       </button> */}
    // this.props.rex.validationInformation
    return (
      <>
      <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
      <div className="dashboard">
        {Object.keys(this.props.rex).length === 0 ?
          <h3 style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</h3>
          :
          <div>
            <div className="dashboard-header">
              <div style={{width: 'calc(100% - 200px)'}}>
                <Progress progression={this.props.rex.progression} 
                            validationInformation = {{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}} 
                            title = {this.props.rex.content.information.name}
                            kind = "Rex"
                  />
              </div>
              <div style={{flex : 1}}> 
              {route ?
                  <Link className="primary-btn filling" style={{float:"right",width:"110px",height:"48px"}} to={route}>Modifier le REX
                  </Link>
                  :
                  null
                }

                  <button onClick={this.handleExtract.bind(this)} className="primary-btn filling" style={{float:"right",width:"156px",height:"48px",marginRight:"20px"}}  >   Extraire le REX    </button>
              </div>
            </div>
            {this.props.rex.content ?
              <div className="dashboard-content">

                <div className="col-1-3">


                  {/*INFORMATION*/}
                  <div className="bloc">
                    <span>Information sur le programme</span>
                    <p className="bloc-content">
                      <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['update-date']} /> {this.props.rex.updatedAt.slice(0, 10)}
                    </p>
                    <p> </p>


                    <p className="bloc-title" style={{ marginBottom: 0 }}>Nom du programme</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>
                      <Link to={"/program/" + this.props.rex.program._id}>   
                        {this.props.rex.program.content.information.name}
                      </Link>
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Project Manager Name</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.firstname + ' ' + this.props.rex.content.information.lastname.toUpperCase()}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Métier</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.trade}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Client</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.client}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Domaine</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.domain}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Localisation</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.localisation}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Secteur</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.sector}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Sous-secteur</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information['sub-sector']}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Duration</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.duration}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Taille de l'équipe IKOS</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.teamsize}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Type d'engagement</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.typology}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Practice</p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>         
                      {this.props.rex.content.information.practice}
                    </p>

                  </div>

            
                </div>

                {/*LEFT PART*/}

                <div className="col-2-3">

                  <h2>Avant le projet : la commande</h2>
                  {this.renderSection_V2(sectionStructure,["requirements.problematic","requirements.answer"])}

                  <h2>Le projet</h2>
                  {this.renderSection_V2(sectionStructure,["project.input","project.equipment","project.planning","project.payload","project.problems"])}

                  <h2>Management – Organisation interne</h2>
                  {this.renderSection_V2(sectionStructure,["management.internal-organization","management.ikos-team"])}

                  <h2>Relation client</h2>
                  {this.renderSection_V2(sectionStructure,["client-relationship.communication","client-relationship.contract"])}

                  <h2>Résultats</h2>
                  {this.renderSection_V2(sectionStructure,["result.objectives","result.follow-up","result.deadlines","result.others"])}

                  <h2>Utilisation du REX des précédents projets</h2>
                  {this.renderSection_V2(["overview","details","feedback"],["previous-rex"])}

                  <h2>REX de votre projets</h2>
                  {this.renderSection_V2(["overview","details","feedback"],["current-rex"])}
                  {this.renderSection_V2(sectionStructure,["skills"])}
                  {this.renderSection_V2(["overview","details"],["technology-watch"])}
                </div>


              </div>
              :
              null
            }

          </div>
        }
      </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  message: state.rex.message,
  rex: state.rex.rex,
  rexExtract: state.rex.rexExtract
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchRex,
  extractRex
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(RexView)));
